import HighwayConditions from '../../pages/HighwayConditions'

export default function Panel() {
  return <HighwayConditions />
}
